import { billingApi } from 'services/businessBilling';
import { centralServerService } from 'services/centralServerService';
import { BillingOriginCancelRequest, BillingOriginCheckRequest, BillingOriginSettlement } from './contracts/BillingOrigin';

export interface PolicyTransportResult { status: number; body: unknown }
const post = async (tenantId: string, token: string, operation: string, data: unknown): Promise<PolicyTransportResult> => {
    const response = await centralServerService.http.instance.request({
        url: `/payment-terminal-attestation/${encodeURIComponent(tenantId)}/billing-details/${encodeURIComponent(token)}/${operation}`,
        method: 'POST', data, headers: { 'Content-Type': 'application/json' },
        transformResponse: (value: unknown) => value, validateStatus: () => true,
    });
    let body: unknown;
    try { body = typeof response.data === 'string' ? JSON.parse(response.data) : response.data; } catch { body = undefined; }
    return { status: response.status, body };
};

export const policyApi = {
    load: (tenantId: string, token: string, verificationToken: string) => billingApi.loadSession(tenantId, token, verificationToken),
    check: (tenantId: string, token: string, request: BillingOriginCheckRequest) => post(tenantId, token, 'checks', request),
    settle: (tenantId: string, token: string, request: BillingOriginSettlement) => post(tenantId, token, 'settlement', request),
    cancel: (tenantId: string, token: string, request: BillingOriginCancelRequest) => post(tenantId, token, 'cancel', request),
};
